<template>

  <v-select :label="label" v-model="val" :items="items"></v-select>

</template>

<script>

export default {
  name: 'TopActionTypeSelector',
  props: ['value', 'label'],
  data: () => ({
    items: [
      'week',
      'month',
      'year'
    ]
  }),
  computed: {
    val: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  mounted () {
    this.$emit('input', this.items[0])
  }
}

</script>



// WEBPACK FOOTER //
// src/components/TopActionTypeSelector.vue